import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/cases/coreka'

const Coreka: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'Coreka コレカ UIUX オブジェクト指向UI OOUI ブランドアーキタイプ'}
        image={'https://www.i3design.jp/ogp_coreka.png'}
        url={'https://www.i3design.jp/cases/coreka'}
        title="マーケティングデータプラットフォーム Coreka | 事例 | i3DESIGN アイスリーデザイン"
        description="アイデア発想を支援するデータプラットフォームSaaS「Coreka（コレカ）」のUI/UX設計全般をサポートしました。このプロダクトは、市場・生活者データを活用し、商品開発におけるアイデア発想を支援するSaaSです。弊社はユーザーのニーズと目的に合わせた最適な情報設計とビジュアルコンセプトの設計に注力しました。"
      />
      <Template />
    </>
  )
}

export default Coreka
